import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { CovanceDatePickerModule } from '../covance-date-picker/covance-date-picker.module';
import { CovanceFilter } from './covance-filter';
import { CovanceFilterComponent } from './covance-filter.component';
import { CovanceChainFilterComponent } from './covance-chain-filter.component';
import { FiltersStorage } from './filters-storage';
import { FilterNameDialogComponent } from './filter-name-dialog.component';
import { CovanceFilterTextTypeComponent } from './filter-type/covance-filter-text-type.component';
import { CovanceFilterNumberTypeComponent } from './filter-type/covance-filter-number-type.component';
import { CovanceFilterNumberRangeTypeComponent } from './filter-type/covance-filter-number-range-type.component';
import { CovanceFilterDateTypeComponent } from './filter-type/covance-filter-date-type.component';
import { CovanceFilterDateRangeTypeComponent } from './filter-type/covance-filter-date-range-type.component';
import { CovanceFilterSelectTypeComponent } from './filter-type/covance-filter-select-type.component';
import { CovanceFilterMultiSelectTypeComponent } from './filter-type/covance-filter-multiselect-type.component';
import { CovanceFilterCheckboxTypeComponent } from './filter-type/covance-filter-checkbox-type.component';
import { CovanceFilterTextType } from './filter-type/covance-filter-text-type';
import { CovanceFilterNumberType } from './filter-type/covance-filter-number-type';
import { CovanceFilterNumberRangeType } from './filter-type/covance-filter-number-range-type';
import { CovanceFilterDateType } from './filter-type/covance-filter-date-type';
import { CovanceFilterDateRangeType } from './filter-type/covance-filter-date-range-type';
import { CovanceFilterSelectType } from './filter-type/covance-filter-select-type';
import { CovanceFilterMultiSelectType } from './filter-type/covance-filter-multiselect-type';
import { CovanceFilterCheckboxType } from './filter-type/covance-filter-checkbox-type';
import { CovanceFilterChainNodeTypeComponent } from './filter-type/covance-filter-chain-node-type.component';
import { ChainNodeDialogComponent } from './chain-node-dialog.component';
import { CovanceFilterChainNodeType } from './filter-type/covance-filter-chain-node-type';
import { CovanceChainFilter } from './covance-chain-filter';
import { CovanceFilterAgeRangeType } from './filter-type/covance-filter-age-range-type';
import { CovanceFilterAgeRangeTypeComponent } from './filter-type/covance-filter-age-range-type.component';
import { CovanceFilterAgeComponent } from './filter-type/covance-filter-age/covance-filter-age.component';
import { CovanceFilterAgeType } from './filter-type/covance-filter-age/covance-filter-age-type';
import { CovanceFilterDateTimeRangeTypeComponent } from './filter-type/covance-filter-date-time-range/covance-filter-date-time-range-type.component';
import { CovanceFilterDateTimeRangeType } from './filter-type/covance-filter-date-time-range/covance-filter-date-time-range-type';

@NgModule({
    declarations: [
        CovanceFilterComponent,
        CovanceChainFilterComponent,
        CovanceFilterChainNodeTypeComponent,
        FilterNameDialogComponent,
        ChainNodeDialogComponent,
        CovanceFilterTextTypeComponent,
        CovanceFilterNumberTypeComponent,
        CovanceFilterNumberRangeTypeComponent,
        CovanceFilterDateTypeComponent,
        CovanceFilterDateRangeTypeComponent,
        CovanceFilterSelectTypeComponent,
        CovanceFilterMultiSelectTypeComponent,
        CovanceFilterCheckboxTypeComponent,
        CovanceFilterAgeRangeTypeComponent,
        CovanceFilterAgeComponent,
        CovanceFilterDateTimeRangeTypeComponent
    ],
    imports: [
        SharedModule,
        CovanceDatePickerModule,
        ReactiveFormsModule
    ],
    exports: [
        CovanceFilterComponent,
        CovanceChainFilterComponent,
        CovanceFilterChainNodeTypeComponent,
        FilterNameDialogComponent,
        CovanceFilterTextTypeComponent,
        CovanceFilterNumberTypeComponent,
        CovanceFilterNumberRangeTypeComponent,
        CovanceFilterDateTypeComponent,
        CovanceFilterDateRangeTypeComponent,
        CovanceFilterSelectTypeComponent,
        CovanceFilterMultiSelectTypeComponent,
        CovanceFilterCheckboxTypeComponent,
        CovanceFilterAgeRangeTypeComponent,
        CovanceFilterAgeComponent,
        CovanceFilterDateTimeRangeTypeComponent
    ],
    providers: [
        CovanceFilter,
        CovanceChainFilter,
        CovanceFilterTextType,
        CovanceFilterNumberType,
        CovanceFilterNumberRangeType,
        CovanceFilterDateType,
        CovanceFilterDateRangeType,
        CovanceFilterSelectType,
        CovanceFilterMultiSelectType,
        CovanceFilterCheckboxType,
        CovanceFilterChainNodeType,
        CovanceFilterAgeRangeType,
        FiltersStorage,
        CovanceFilterAgeType,
        CovanceFilterDateTimeRangeType
    ],
    entryComponents: [
        FilterNameDialogComponent,
        ChainNodeDialogComponent,
        CovanceFilterTextTypeComponent,
        CovanceFilterNumberTypeComponent,
        CovanceFilterNumberRangeTypeComponent,
        CovanceFilterDateTypeComponent,
        CovanceFilterDateRangeTypeComponent,
        CovanceFilterSelectTypeComponent,
        CovanceFilterMultiSelectTypeComponent,
        CovanceFilterCheckboxTypeComponent,
        CovanceFilterAgeRangeTypeComponent,
        CovanceFilterAgeComponent,
        CovanceFilterDateTimeRangeTypeComponent
    ]
})
export class CovanceFilterModule { }
